const styles = theme => {
    return {
        root: {
            height: "80vh",
            display: "grid",
            gridTemplateColumns: "63% 37%"
        },
        boxHolder: {
            padding: "10px"
        },
        textField: {
            marginLeft: '0px',
            marginRight: '0px',
        },
        searchtextField: {
            marginLeft: '0px',
            marginRight: '0px',
            width:'50%',
        },
        scantextField: {
            marginLeft: '0px',
            marginRight: '0px',
            width:'50%',
        },
        TableHeadTop: {
            border: '1px solid rgba(224, 224, 224, 1)',
            fontSize:'1.2em !important',
            fontWeight:'500 !important',
            textAlign:'center',
            width:'50%'
        },
        TableHead: {
            border: '1px solid rgba(224, 224, 224, 1)',
            fontSize:'1em !important',
            fontWeight:'500 !important'
        },
        table:{
            border: '1px solid rgba(224, 224, 224, 1)',
            padding:0
        },
        layoutBorder:{
            border:'none',
            padding:'5px',
            paddingRight: '0px !important'
        },
        cursorIcon:{
            cursor:'pointer'
        },
        adjustDrugGrid:{
            margin: '-7% 0% 0% 0%'
        },
        commonFontSize:{
            fontSize:'1em'
        },
        removeIcon:{
            border:'none',
            width:'30px',
            padding:'0'
        },
        iconButton: {
            padding: 10,
        },
        trHeight:{
            height:'20px'
        },
        buttonContainer: {
            flexGrow: '1',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            padding: '2% 0px',
            justifyContent: 'flex-end'
        },
        assignForm: {
            // display: "grid",
            alignItems:'flex-start',
            // gridTemplateColumns: "42% 29% 29%",
            // gridTemplateRows: "100px 250px auto",
            // padding: "15px 5%",
            padding: "1.5%",
            // gridGap:'1em'
        },
        paper: {
            padding: '0px',
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        box: {
            display: "grid",
            gridTemplateColumns: "1fr 1.5fr 1fr 1fr 1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
            gridColumnGap: "7px",
            gridRowGap: "7px",
            justifyItems: "stretch",
            alignItems: "stretch",
            height: "100%"
        },
        // bin: {
        //     width: "100%",
        //     height: "100%",
        //     background: "rgb(255,255,255)",
        //     background:"linear-gradient(148deg, rgba(255,255,255,1) 0%, rgba(219,255,239,1) 77%, rgba(99,242,182,1) 100%)",
        //     borderRadius: "5px",
        //     boxShadow:"0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
        // },
        // upperMidBin: {
        //     gridRow: "2 / span 2",
        //     gridColumn: "3 / span 2",
        //     width: "100%",
        //     height: "100%",
        //     background: "rgb(255,255,255)",
        //     background:"linear-gradient(148deg, rgba(255,255,255,1) 0%, rgba(219,255,239,1) 77%, rgba(99,242,182,1) 100%)",
        //     borderRadius: "5px",
        //     boxShadow:"0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
        // },
        displayBin: {
            gridRow: "4 / span 5",
            gridColumn: "3 / span 2",
            width: "100%",
            height: "100%",
            borderRadius: "5px",
            boxShadow:"0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
        },
        columnTitle: {
            textAlign: "center",
            marginTop: "auto",
            marginBottom: "auto"
        },
        rowTitle: {
            textAlign: "center",
            marginTop: "auto",
            marginBottom: "auto"
        },
        patientInfo: {
            paddingTop: "20px"
        },
        patientNameText: {
            fontSize: "2em"
        },
        patientDoBText: {},
        rxInput: {
            gridColumn: "1 / span 3"
        },
        rxInfo: {
            paddingTop: "20px"
        },
        rxItems: {
            gridColumn: "1 / span 3",
        },
        cancel: {},
        save: {},
        accountBoxSelectionContainer: {
            display: "grid",
            gridTemplateColumns: "50% 50%",
            paddingLeft: "80px",
            paddingRight: "80px",
            paddingTop: "20px",
            gridGap: "40px"
        },
        boxSide: {
            display: "grid",
            gridTemplateRows: "40px auto"
        },
        boxDesign: {
            height:'369px',
            width:'180px',
            // border:'1px solid #888',
            // borderRadius:'25px',
            padding:'15px',
            //marginTop: '-85px',
            boxShadow: 'none'
        },
        boxLogo: {
            float:'left',
            height:'40px',
            width:'40%',
            border:'1px solid #888',
            // background:'#ccc',
            borderRadius:'5px',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
        },
        stockCode: {
            // display:'flex',
            // alignItems:'center',
            // justifyContent:'center',
            textAlign: 'center',
            lineHeight: '20px'
            //width:'100%',
            // height: '130px',
        },
        spacer: {
            width:'5%'
        },
        boxcontainer: {
            width: '100%',
            float:'left',
            display:'flex',
            alignItems:'center'
        },
        boxLogoDesc: {
            float:'left',
            color:'#000',
            fontSize:'10px',
            display:'inline-flex',
            width:'65%',
        },
        deliveryContainer: {
            width:'100%',
            marginTop:'5%',
            borderBottom:'1px solid #000',
            float:'left',
            fontSize:'10px',
            padding:'5px 0px',
        },
        prescriptionContainer:{
            width:'100%',
            marginTop:'5%',
            float:'left',
            fontSize:'10px',
            padding:'5px 0px',
            lineHeight:'15px'
        },
        qrcodeContainer:{
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            width:'100%',
            float:'left',
            //height: '130px',
        },
        img: {
            height:'70px',
            width:'70px'
        },
        dialogBackground: {
            background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)'
          },
          dialogContentColor: {
            color: '#387371',
            textAlign: 'center',
            fontSize: '1.5em'
          },
          dialogTitleColor: {
            color: '#387371',
            textAlign: 'left',
            fontSize: '1.2em'
          },
          alignButton: {
            justifyContent: 'center',
            alignItems: 'center'
          },
          buttonColor: {
            color: '#387371',
            fontSize: '1.5em'
          },
          messageInfo: {
            textAlign: 'center'
          },
          handleOverflow:{
            // maxHeight:'170px',
            // maxHeight:'115px',
            height:'210px',
            maxHeight:'210px',
            overflow:'auto',
            border: '3px solid rgb(74, 107, 167)',
          },
          boxType: {
            marginRight: "20px",
            width: 500,
            marginLeft: '0px',
          },
          th: {
            padding:'4px 0px 4px 0px'
          },
          selectLable: {
            marginBottom: '-18px',
            color: 'red',
          },
          emptyRowCell : {
            textAlign: 'center'
          },
          pauseButton: {
            fontSize: '20px !important',
            fontFamily: 'Material Icons',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1',
            letterSpacing: 'normal',
            textTransform: 'none',
            display: 'inline-block',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            direction: 'ltr',
          },
          tableCell:{
            padding:'0px !important'
          },
          spinner:{
            position: 'absolute',
            background: 'rgba(255,255,255,.4)',
            width: '100%',
            height: '100%',
            zIndex: '9999',
            top: 0,
            left: 0,
          },
          spinnerImage:{
            top: 'calc(50% - 32.5px)',
            left: 'calc(50% - 65px)',
            position: 'absolute',
            width: '130px',
            userSelect:'none'
          },
          hidden :{
              display:'none'
           },
        tableCart:{
            border: '3px solid rgb(74, 107, 167)',
            padding:0
        },
        textArea:{
            resize: 'none',
            borderRadius: '5px',
            paddingLeft: '5px',
            width: '100%'
        },
        padiGridCell: {
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '1rem',
            fontWeight: 500,
            textAlign: 'right',
            borderBottom: 'none',
            padding: '4px 25px 4px 24px !important'
        },
        main:{
            display:'flex',
            flexDirection:'row'
        },
        codetable:{
            fontSize:'1.6rem',
            marginLeft:'100px',
            marginTop:'-40px',
            lineHeight:'2em',
            textAlign:'center'
        },
        stock:{
            marginLeft:'10px',
            color:'#0a5d66',
            fontWeight:500,
        },
        pickuptitle:{
            marginLeft:'20px'
        },
        searchArea:{
            display:'flex',
            justifyContent:'flex-end',
            marginTop:'-80px',
            marginBottom:'30px'
        },
          '@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)':{
            root: {
                height: "78vh",
                display: "grid",
                width:"100vh",
                gridTemplateColumns: "85% 0%"
            },
            assignForm: {
                alignItems:'flex-start',
                padding: "30px 5%",
                width:'650px'
            },
            boxHolder: {
                padding: "30px 0px"
            },
            adjustDrugGrid:{
                margin: '-10% 0% 0% 0%'
            },
          },
        '@media print':
        {
            body :
            {
                width:'192px',
                height:'384px'
            }
        },
        '@media only screen and (min-width: 1280px) and (max-width:1366px) and (orientation:landscape)' :{
        root: {
            height: "auto",
            display: "grid",
            width:"78%",
            gridTemplateColumns: "85% 0%"
        },

      },

    }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/console/labelTemplate.styles.js